export const MASONRY_BREAKPOINTS = {
    default: 3,
    2560: 6,
    2240: 5,
    1920: 4,
    1600: 3,
    1280: 2,
};
export const MASONRY_BREAKPOINTS_RELATED_TEMPLATES = {
    default: 4,
    2560: 6,
    2240: 5,
    1920: 4,
    1600: 4,
    1280: 3,
};
export const RELATED_TEMPLATE_PAGE_SIZE = 16;
export const CARD_HEIGHT_MAP = {
    '16:9': 'iv-pt-template-hh',
    '1:1': 'iv-pt-template',
    '9:16': 'iv-pt-template-vh',
};
export const FILTER_ORDER = ['d', 'c', 'i'];
export const FACET_NAMES = {
    d: 'Aspect ratio',
    c: 'Type',
    i: 'Industry',
};
export const INDUSTRY_SUBCATEGORIES = {
    'real estate': [
        'Property Listings',
        'Just Sold',
        'Tips & Tricks',
        'Market Updates',
        'Post Card Videos',
        'Ads',
        'Open House',
        'Meme videos',
        'Portfolio showcase',
        'Testimonials',
        'Trending',
    ],
    'health & fitness': [
        'Tips and tricks',
        'Diet and nutrition',
        'Yoga and meditation',
        'Strength training',
        'Myths and facts',
        'Promos and ads',
    ],
    'health and fitness': [
        'Tips and tricks',
        'Diet and nutrition',
        'Yoga and meditation',
        'Strength training',
        'Myths and facts',
        'Promos and ads',
    ],
    fashion: [
        'Sales and offers',
        'Promos and ads',
        'Collections and slideshows',
        'Intros and outros',
        'Shows and expos',
        'Lookbook',
    ],
    health_fitness: [
        'Intros',
        'Outros',
        'Logo reveals',
        'Fitness myths and facts',
        'Brand and product promos',
        'Transformation',
        'Tips and tricks',
        'Yoga and meditation',
        'Motivational posters and slideshows',
        'Diet and nutrition',
        'Listicles',
        'Gym videos',
        'Testimonials',
    ],
    gaming: [
        'Intros',
        'Outros',
        'Logo reveals',
        'Stream pause',
        'Stream start',
        'Stream end',
    ],
    technology: [
        'Offers and Discounts',
        'Intros and logo reveals',
        'Reviews',
        'Webinars and conferences',
        'Listicles',
    ],
    music: [
        'Concerts and parties',
        'Promos and ads',
        'Intros and outros',
        'Events and invites',
    ],
    photography: [
        'Wedding',
        'Cameras and equipment',
        'Workshops and tutorials',
        'Shoot packages',
        'Portfolio showcase',
        'Studio ads',
    ],
    finance: [
        'Ads and promos',
        'Listicles',
        'News',
        'Personal finance',
        'Investing tips',
        'Tax',
    ],
    'Food & Beverage': [
        'Ads and offers',
        'Restaurant promos',
        'Video recipes',
        'Diet and nutrition',
        'Reviews and testimonials',
        'Intros and outros',
    ],
    travel: [
        'Listicles',
        'Holidays and tourism',
        'Testimonials ',
        'Packages and tours',
        'Agency ads',
        'Slideshows and collages',
    ],
    sports: [
        'Highlight videos',
        'Academy ads',
        'Match previews and posters',
        'Testimonials',
        'Football',
        'Promos and ads',
    ],
};
const WHITE_LISTED_TYPE_OF_FILTERS = [
    'ads',
    'announcements',
    'case study',
    'explainer',
    'greetings',
    'how-to',
    'intros',
    'invitations',
    'listicles',
    'logo reveals',
    'motion posters',
    'outros',
    'promos',
    'sales & offers',
    'slideshow',
    'testimonials',
    'trends',
    'tutorial',
    'video presentation',
    'vlogs',
];
const WHITE_LISTED_INDUSTRIES_FILTERS = [
    'animals',
    'art',
    'automobiles',
    'beauty',
    'consulting',
    'ecommerce',
    'education',
    'entertainment',
    'environment',
    'events & holidays',
    'fashion',
    'finance',
    'food & beverage',
    'gaming',
    'health & fitness',
    'healthcare',
    'music',
    'photography & video',
    'professional services',
    'real estate',
    'sports',
    'technology',
    'travel',
];
const WHITE_LISTED_ASPECT_RATIO = ['16:9', '1:1', '9:16'];
export const WHITE_LISTED_FACETS = {
    d: WHITE_LISTED_ASPECT_RATIO,
    c: WHITE_LISTED_TYPE_OF_FILTERS,
    i: WHITE_LISTED_INDUSTRIES_FILTERS,
};
export const TEMPLATE_PAGE_SIZE = 18;
export const TEXT_TO_VIDEO_PAGE_SIZE = 100;
